import React, { useMemo } from 'react';

// Simple embed component to render custom HTML code
// By default, <script> tags are stripped for safety. Enable "allowScripts" to keep them.
const EmbedHtmlComponent = ({ html = '', allowScripts = false, containerClass = '' }) => {
  console.log('EmbedHtml component loaded');
  
  const sanitized = useMemo(() => {
    if (allowScripts) return html || '';
    try {
      // strip <script>...</script> blocks (very simple safeguard)
      return (html || '').replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
    } catch (e) {
      console.error('Error sanitizing HTML:', e);
      return html || '';
    }
  }, [html, allowScripts]);

  // Debug logging
  console.log('EmbedHtml rendering:', { html, allowScripts, containerClass, sanitized });

  try {
    return (
      <div className={`w-full ${containerClass || ''}`} dangerouslySetInnerHTML={{ __html: sanitized }} />
    );
  } catch (error) {
    console.error('Error rendering EmbedHtml:', error);
    return <div className={`w-full ${containerClass || ''}`}>Error rendering HTML: {error.message}</div>;
  }
};

export const EmbedHtml = {
  fields: {
    html: {
      type: 'textarea',
      label: 'HTML Code',
      placeholder: '<div>Mein eigener Code</div>'
    },
    allowScripts: {
      type: 'radio',
      label: 'Skripte erlauben (unsicher)',
      options: [
        { label: 'Ja', value: true },
        { label: 'Nein', value: false }
      ]
    },
    containerClass: {
      type: 'text',
      label: 'Wrapper CSS Klassen',
      placeholder: 'w-full'
    }
  },
  defaultProps: {
    html: '<div style="padding:16px;border:1px dashed #cbd5e1;text-align:center">Benutzerdefinierter HTML-Block</div>',
    allowScripts: false,
    containerClass: 'flex justify-center'
  },
  render: EmbedHtmlComponent
};


